<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div v-if="!isReply">
      <div class="search-class">
        <el-form
          :model="searchTxt"
          :inline="true"
          size="small"
          class="serarch-form"
          label-position="right"
          label-width="90px"
        >
          <el-form-item label="账号">
            <el-select
              v-model="searchTxt.account"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(item, index) in dropList.account"
                :label="item"
                :value="item"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回复状态">
            <el-select
              v-model="searchTxt.replyStatus"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.replyStatus"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="已读状态">
            <el-select
              v-model="searchTxt.readStatus"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.readStatus"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input
              class="input-width"
              v-model="orderIds"
              type="textarea"
              autosize
              placeholder="支持批量换行查询"
            ></el-input>
          </el-form-item>
          <el-form-item label="客服人员">
            <el-select
              v-model="searchTxt.receptionist"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.receptionist"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="重要消息">
            <el-select
              v-model="searchTxt.important"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.important"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回复时间">
            <el-date-picker
              v-model="searchTxt.replyTimeStart"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.replyTimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收件时间">
            <el-date-picker
              v-model="searchTxt.createTimeStart"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.createTimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              style="margin-left: 50px"
              type="primary"
              @click="search()"
              icon="el-icon-search"
              >查找</el-button
            >
            <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="main-table">
        <div class="table-header">
          <el-button
            @click="batchIsReply"
            class="button-class"
            type="primary"
            v-if="$buttonAuthority(allButton, 'batchMarking')"
            >批量标记已回复</el-button
          >
        </div>
        <el-tabs
          style="margin-top: 10px"
          v-model="searchTxt.chatType"
          type="card"
          @tab-click="search"
        >
          <el-tab-pane label="买家信息" name="2"></el-tab-pane>
          <el-tab-pane label="平台信息" name="1"></el-tab-pane>
        </el-tabs>
        <commonTable
          ref="multipleTable"
          type="selection"
          :loading="loading"
          :tableData="tableData"
          :tableLabel="tableLabel"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :pageSize="pagination.pageSize"
          :currentPage="pagination.page"
          :total="total"
          @handleSelectionChange="handleSelectionChange"
          :tableOption="tableOption"
          @handleButton="handleButton"
        ></commonTable>
      </div>
      <div v-if="isLog">
        <logLook
          :modelName="modelName"
          :logType="logType"
          :id="scope.id"
          @lookClick="isShowEdit"
        ></logLook>
      </div>
    </div>
    <div v-if="isReply">
      <replay
        :scope="scope"
        @isShowEdit="isShowEdit"
        @getList="getList"
      ></replay>
    </div>
  </div>
</template>
<script>
/**
 * Ozon 平台邮件列表页
 * 功能：买家信息/平台信息双 Tab，多条件搜索（账号、回复/已读状态、批量订单号、客服、重要、时间区间），
 *       支持批量标记已回复、单条标记已读/重要（星标）、查看消息详情、查看日志
 */
import {
  getOzonMessageList,
  setReplyBatch,
  setRead,
  markImportant,
} from "@/api/user";
import replay from "../components/replay";
export default {
  components: { replay },
  data() {
    return {
      modelName: "mail",
      logType: "ozonMessage",
      // 列表加载状态
      loading: true,
      isshowhidden: false,
      // 是否首次加载（首次加载后生成列定义）
      isFirst: true,
      // 是否打开日志弹窗
      isLog: false,
      // 是否进入消息详情页
      isReply: false,
      // 是否打开更换客服弹窗
      isUpdata: false,
      // 当前选中行数据
      scope: {},
      // 按钮权限列表
      allButton: [],
      // 邮件列表数据
      tableData: [],
      // 表格列定义
      tableLabel: [],
      // 后端返回的列标题映射
      titleMap: [],
      dropList: {},
      renderList: {},
      // 批量勾选的邮件数据
      dataList: [],
      // 批量订单号输入内容（支持换行分隔）
      orderIds: "",
      // 搜索条件
      searchTxt: {
        account: "",
        replyStatus: "",
        readStatus: "",
        receptionist: "",
        important: "",
        chatType: "2",
        replyTimeStart: "",
        replyTimeEnd: "",
        createTimeStart: "",
        createTimeEnd: "",
        orderIdList: [],
      },
      isCheck: false,
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
      },
      // 总条数
      total: 0,
      // 表格操作列定义（查看消息、标记已读、日志）
      tableOption: {
        label: "操作",
        width: "170",
        fixed: "right",
        options: [
          {
            label: "查看消息",
            type: "text",
            methods: "see",
            size: "mini",
          },
          {
            label: "标记已读",
            type: "text",
            methods: "markAsRead",
            size: "mini",
            disabled: (data) => {
              if (data.readStatus == 2) {
                return true;
              }
            },
          },
          {
            label: "日志",
            type: "text",
            methods: "log",
            size: "mini",
          },
        ],
      },
    };
  },
  created() {
    // 组件创建时获取按钮权限并加载列表
    this.allButton = this.$getStorage(this.$route.name + "_button");
    if (this.$buttonAuthority(this.allButton, "list")) {
      Object.assign(this.pagination, this.searchTxt);
      this.getList();
    }
  },
  methods: {
    /** 基于后端列映射生成表格列定义（替换为已读状态列与重要邮件星标列） */
    getTableLabel() {
      this.tableLabel = this.$getTableLabel(this.titleMap, this.dropList);
      let readStatus = {
        label: "已读状态",
        param: "readStatus",
        align: "center",
        show: true,
        render: (h, param) => {
          let icon = "";
          if (param.row.readStatus == 1) {
            icon = h(
              "span",
              {
                class: "badge",
              },
              param.row.unreadCount
            );
          }
          return h("div", [
            icon,
            h(
              "p",
              this.$getText(param.row.readStatus, this.dropList.readStatus)
            ),
          ]);
        },
      };
      let important = {
        label: "重要邮件",
        param: "important",
        align: "center",
        width: "90px",
        show: true,
        render: (h, param) => {
          let img = h("div", {
            class: param.row.important == 1 ? "start" : "no-start",
            style: {
              fontSize: "20px",
              cursor: "pointer",
            },
            on: {
              click: () => {
                this.singClick(param.row);
              },
            },
          });
          return [img];
        },
      };
      this.tableLabel.splice(2, 2, readStatus);
      this.tableLabel.splice(3, 1, important);
      this.loading = false;
    },
    // 标记为重要邮件
    singClick(row) {
      let param = {
        id: row.id,
      };
      markImportant(param).then((result) => {
        if (result.code == 200) {
          this.$message.success(result.msg);
          this.getList();
        }
      });
    },
    /** 查询 Ozon 邮件列表 */
    getList() {
      this.loading = true;
      getOzonMessageList(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records;
          this.total = result.data.pageInfo.total;
          let label = result.data.renderList;
          this.dropList = result.data.dropList;
          if (label == null) {
            this.renderList = {};
          } else {
            Object.assign(this.renderList, label);
          }
          if (this.isFirst) {
            this.titleMap = result.data.titleMap;
            this.getTableLabel();
          } else {
            this.loading = false;
          }
          this.$refs.multipleTable.clear();
        }
      });
    },
    // 批量标记已回复
    batchIsReply() {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        let param = {
          ids: ids,
        };
        setReplyBatch(param)
          .then((result) => {
            if (result.code == 200) {
              this.$message.success(result.msg);
              this.getList();
              this.$refs.multipleTable.clear();
            }
          })
          .catch(() => {});
      } else {
        this.$message.error("请勾选需要操作的数据项！");
      }
    },

    /** 关闭所有弹窗/详情页，回到列表 */
    isShowEdit() {
      this.scope = {};
      this.isLog = false;
      this.isReply = false;
      this.isUpdata = false;
    },
    /** 表格操作列按钮分发（查看消息/标记已读/日志） */
    handleButton(data) {
      var funType = data.methods;
      if (funType === "see") {
        this.toReply(data.row);
      } else if (funType === "markAsRead") {
        this.batchIsRead(data.row);
      } else if (funType === "log") {
        this.scope = data.row;
        this.isLog = true;
      }
    },
    // 邮件详情
    toReply(row) {
      this.scope = row;
      this.isReply = true;
    },
    // 标记已读
    batchIsRead(data) {
      let param = {
        id: data.id,
      };
      setRead(param).then((result) => {
        if (result.code == 200) {
          this.$message.success(result.msg);
          this.getList();
        }
      });
    },
    /** 分页大小变化时重新查询 */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getList();
    },
    /** 页码变化时重新查询 */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getList();
    },
    /** 勾选变化时记录选中的邮件数据 */
    handleSelectionChange(value) {
      this.dataList = value;
    },
    /** 按搜索条件查询（批量订单号按换行切分为数组） */
    search() {
      this.searchTxt.orderIdList = this.$splitText(this.orderIds);
      Object.assign(this.pagination, this.searchTxt);
      this.isFirst = false;
      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.getList();
    },
    /** 清空搜索条件（保留默认买家信息 Tab）并重新查询 */
    reset() {
      this.orderIds = "";
      this.isFirst = false;
      this.isCheck = false;
      this.$delectObj(this.searchTxt);
      this.searchTxt.orderIdList = [];
      this.searchTxt.chatType = "2";
      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      Object.assign(this.pagination, this.searchTxt);
      this.getList();
    },
  },
};
</script>